import { Flex, Text } from "@radix-ui/themes";
import { FC } from "react";

interface NumberFieldRowProps {
  value?: number | null;
}

export const NumberFieldRow: FC<NumberFieldRowProps> = ({ value }) => {
  if (!value) {
    return <div />;
  }

  return (
    <Flex align="center" justify="start" pl="1" pr="1">
      <Text size="1">{value}</Text>
    </Flex>
  );
};
